/**
 * @generated SignedSource<<622fd207c13aed468d15abc63b429bf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedStoryTellingTab_storyTellingTab$data = {
  readonly mainImage: string | null;
  readonly mainVideo: string | null;
  readonly smallImage: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedStoryTellingText_storyTellingTab" | "PdpSharedStoryTellingMainMedia_refactor_storyTellingTab" | "PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab">;
  readonly " $fragmentType": "PdpRespSharedStoryTellingTab_storyTellingTab";
};
export type PdpRespSharedStoryTellingTab_storyTellingTab$key = {
  readonly " $data"?: PdpRespSharedStoryTellingTab_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedStoryTellingTab_storyTellingTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedStoryTellingTab_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainVideo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallImage",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedStoryTellingText_storyTellingTab"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedStoryTellingMainMedia_refactor_storyTellingTab"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab"
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};

(node as any).hash = "53170eee6638b708953bb9c20ce792ef";

export default node;
